import {
  TableBody,
  TableRow,
  TableCell,
  Radio,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Stack,
  Avatar,
  IconButton,
  CircularProgress,
  Switch,
} from "@mui/material";
import { deepPurple, orange, cyan, brown, blue } from "@mui/material/colors";
import Iconify from "../iconify/Iconify";
import { PlayerHeadshot } from "../PlayerHeadshot";
import { getPositionLetter } from "src/utils/positionUtils";
import { getPositionsForSport } from "src/utils/scoreablesDashboardUtils";
import AnalyticsIcon from "@mui/icons-material/Analytics";

export default function ScoreablesTableBody({
  scoreables,
  handleVisibilityChange,
  ratings,
  imageHash,
  editScoreableNameIds,
  editPositionIds,
  uploadingImageIds,
  loadingScoreableId,
  handleChangeRating,
  handleCheckboxChange,
  showEditName,
  handleChangeName,
  handlePositionChange,
  showEditPosition,
  uploadPlayerImage,
  handleDeleteClick,
  setEditPositionIds,
  handleInjuryChange,
  onStageScoringStatsClick,
  sport,
}) {
  return (
    <TableBody>
      {scoreables.map((row, index) => (
        <TableRow
          key={index}
          sx={{
            "&:last-child td, &:last-child th": { border: 0 },
          }}
        >
          <TableCell component="th" scope="row">
            {row.scoreableId}
          </TableCell>
          <TableCell component="th" scope="row">
            {row.externalRef}
          </TableCell>
          <TableCell component="th" scope="row">
            {index === 0 && (
              <Switch
                checked={!!row.visibility}
                color="success"
                onChange={(e) => handleVisibilityChange(e, row.scoreableId)}
              />
            )}
          </TableCell>
          <TableCell component="th" scope="row">
            <Radio
              checked={row.rating === 2}
              onChange={(event) => handleChangeRating(event, row.scoreableId)}
              value={2}
              name="radio-buttons"
              inputProps={{ "aria-label": "B" }}
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: 24,
                },
                color: orange[800],
                "&.Mui-checked": {
                  color: orange[600],
                },
              }}
            />
            <Radio
              checked={row.rating === 1}
              onChange={(event) => handleChangeRating(event, row.scoreableId)}
              value={1}
              name="radio-buttons"
              inputProps={{ "aria-label": "B" }}
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: 24,
                },
                color: cyan[800],
                "&.Mui-checked": {
                  color: cyan[600],
                },
              }}
            />
            <Radio
              checked={row.rating === 0}
              onChange={(event) => handleChangeRating(event, row.scoreableId)}
              value={0}
              name="radio-buttons"
              inputProps={{ "aria-label": "B" }}
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: 24,
                },
                color: brown[800],
                "&.Mui-checked": {
                  color: brown[600],
                },
              }}
            />
            <Radio
              checked={row.rating === 3}
              onChange={(event) => handleChangeRating(event, row.scoreableId)}
              value={3}
              name="radio-buttons"
              inputProps={{ "aria-label": "B" }}
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: 24,
                },
                color: blue[800],
                "&.Mui-checked": {
                  color: blue[600],
                },
              }}
            />
          </TableCell>
          <TableCell component="th" scope="row">
            <FormControlLabel
              control={
                <Checkbox
                  checked={row.isActive}
                  onChange={(e) =>
                    handleCheckboxChange(e, row.scoreableId, "isActive")
                  }
                  id="isActive"
                />
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={row.canGenerate}
                  onChange={(e) =>
                    handleCheckboxChange(e, row.scoreableId, "canGenerate")
                  }
                  id="canGenerate"
                />
              }
            />
          </TableCell>
          <TableCell component="th" scope="row" sx={{ maxWidth: 150 }}>
            <FormControl sx={{ m: 1 }} size="small">
              <InputLabel id="season-select-label">Injury</InputLabel>
              <Select
                labelId="season-select-label"
                id="season-select"
                value={row.injuryStatus || 0}
                label="Injury"
                onChange={(event) => handleInjuryChange(event, row.scoreableId)}
              >
                <MenuItem value={0}>
                  None
                </MenuItem>
                <MenuItem value={1}>
                  Day-to-Day
                </MenuItem>
                <MenuItem value={2}>
                  Injured
                </MenuItem>
                <MenuItem value={3}>
                  Out
                </MenuItem>
              </Select>
            </FormControl>
          </TableCell>
          <TableCell component="th" scope="row" sx={{ maxWidth: 150 }}>
            {!editScoreableNameIds.includes(row.scoreableId) && (
              <>
                {row.displayName}
                <Iconify
                  icon={"eva:edit-outline"}
                  sx={{ cursor: "pointer" }}
                  onClick={() => showEditName(row.scoreableId)}
                />
              </>
            )}
            {editScoreableNameIds.includes(row.scoreableId) && (
              <Grid container>
                <Grid item xs={12}>
                  <TextField
                    id="firstname"
                    label="First Name"
                    fullWidth
                    value={row.firstname}
                    variant="standard"
                    onChange={(e) => handleChangeName(e, row.scoreableId)}
                  />
                </Grid>
                {row.teamExternalRef && (
                  <Grid item xs={12}>
                    <TextField
                      id="lastname"
                      label="Last Name"
                      fullWidth
                      value={row.lastname}
                      variant="standard"
                      onChange={(e) => handleChangeName(e, row.scoreableId)}
                    />
                  </Grid>
                )}
                {!row.teamExternalRef && (
                  <Grid item xs={12}>
                    <TextField
                      id="shortname"
                      label="Short Name"
                      fullWidth
                      value={row.shortname}
                      variant="standard"
                      onChange={(e) => handleChangeName(e, row.scoreableId)}
                    />
                  </Grid>
                )}
              </Grid>
            )}
          </TableCell>
          <TableCell component="th" scope="row">
            {row.teamExternalRef ? (
              editPositionIds.includes(row.scoreableId) ? (
                <FormControl fullWidth size="small">
                  <Select
                    value={row.position}
                    onChange={(e) => handlePositionChange(e, row.scoreableId)}
                    onBlur={() =>
                      setEditPositionIds(
                        editPositionIds.filter((id) => id !== row.scoreableId)
                      )
                    }
                    autoFocus
                  >
                    {getPositionsForSport(sport).map((pos) => (
                      <MenuItem key={pos.value} value={pos.value}>
                        {pos.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Avatar sx={{ bgcolor: deepPurple[500] }}>
                    {getPositionLetter(row.position)}
                  </Avatar>
                  <Iconify
                    icon={"eva:edit-outline"}
                    sx={{ cursor: "pointer" }}
                    onClick={() => showEditPosition(row.scoreableId)}
                  />
                </Stack>
              )
            ) : (
              <Avatar sx={{ bgcolor: deepPurple[500] }}>
                {getPositionLetter(row.position)}
              </Avatar>
            )}
          </TableCell>
          <TableCell component="th" scope="row">
            <Grid container spacing={1} alignItems="center">
              <Grid item>
                <PlayerHeadshot row={row} imageHash={imageHash} />
              </Grid>
              {process.env.REACT_APP_LEAGUE?.toLowerCase() !== "nhl" && (
                <Grid item>
                  {uploadingImageIds.includes(row.scoreableId) ? (
                    <CircularProgress size={20} />
                  ) : (
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="label"
                      size="small"
                    >
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={(event) => uploadPlayerImage(event, row)}
                      />
                      <Iconify icon={"eva:upload-outline"} />
                    </IconButton>
                  )}
                </Grid>
              )}
            </Grid>
          </TableCell>
          {ratings && (
            <TableCell component="th" scope="row">
              {row.cardCount}
            </TableCell>
          )}
          <TableCell align="right">
            {loadingScoreableId === row.scoreableId ? (
              <CircularProgress size={24} />
            ) : (
              <IconButton color="error" onClick={() => handleDeleteClick(row)}>
                <Iconify icon={"eva:close-circle-outline"} />
              </IconButton>
            )}
            <IconButton
              size="small"
              color="primary"
              onClick={() => onStageScoringStatsClick(row.scoreableId)}
              title="View Stage Scoring Stats"
            >
              <AnalyticsIcon fontSize="large" />
            </IconButton>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
}
